/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ summary: NonNullable<unknown> }} Recovery_LabelInputs */

const en_us2_recovery_label = /** @type {(inputs: Recovery_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Readiness map: green is recovered, red still tired. ${i?.summary}`)
};

const pt_br2_recovery_label = /** @type {(inputs: Recovery_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mapa de prontidão: verde está recuperado, vermelho ainda cansado. ${i?.summary}`)
};

const es_419_recovery_label = /** @type {(inputs: Recovery_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mapa de disposición: verde está recuperado, rojo todavía cansado. ${i?.summary}`)
};

const pt_pt2_recovery_label = /** @type {(inputs: Recovery_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mapa de prontidão: verde está recuperado, vermelho ainda cansado. ${i?.summary}`)
};

const fr_fr2_recovery_label = /** @type {(inputs: Recovery_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carte de récupération : vert = récupéré, rouge = encore fatigué. ${i?.summary}`)
};

const de_de2_recovery_label = /** @type {(inputs: Recovery_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bereitschaftskarte: Grün ist erholt, Rot noch müde. ${i?.summary}`)
};

const it_it2_recovery_label = /** @type {(inputs: Recovery_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mappa della prontezza: verde è recuperato, rosso ancora affaticato. ${i?.summary}`)
};

/**
* | output |
* | --- |
* | "Readiness map: green is recovered, red still tired. {summary}" |
*
* @param {Recovery_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const recovery_label = /** @type {((inputs: Recovery_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_recovery_label(inputs)
	if (locale === "es-419") return es_419_recovery_label(inputs)
	if (locale === "pt-PT") return pt_pt2_recovery_label(inputs)
	if (locale === "fr-FR") return fr_fr2_recovery_label(inputs)
	if (locale === "de-DE") return de_de2_recovery_label(inputs)
	if (locale === "it-IT") return it_it2_recovery_label(inputs)
	return en_us2_recovery_label(inputs)
});
export { recovery_label as "recovery.label" }